// extracted by mini-css-extract-plugin
module.exports = {"text":"headlineSkins-xlarge-text-d7a84c7e"};